import { render, staticRenderFns } from "./SatuSehat.vue?vue&type=template&id=7231a48a"
import script from "./SatuSehat.vue?vue&type=script&lang=js"
export * from "./SatuSehat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports